import { Middleware } from "@reduxjs/toolkit";
import { RootState } from "..";
import {
  setHullConfiguration,
  setSpecializedHull,
  setAdditionalHull,
  setHullAndArmorStats,
  setHull,
} from "../features/shipBuilderSlice";
import { calculateHullAndArmorStats } from "../../utils/calculations/hullAndArmorCalculations";

const hullAndArmorMiddleware: Middleware<{}, RootState> =
  (store) => (next) => (action: any) => {
    // First, let the action pass through and update the state
    const result = next(action);

    // Now, check if this is one of the actions we care about
    if (
      setHull.match(action) ||
      setHullConfiguration.match(action) ||
      setSpecializedHull.match(action) ||
      setAdditionalHull.match(action)
    ) {
      // Get the *new* state after the reducers have run
      const state = store.getState().shipBuilder;
      const { shipSize, hull, techLevel } = state;

      // Skip calculation if state is not properly initialized
      // Allow calculation if bridge is selected even if hull is not configured
      if ((!shipSize || shipSize <= 0 || !hull) && !state.bridge) {
        console.log("hullAndArmorMiddleware: Skipping calculation - state not initialized and no bridge selected");
        return result;
      }

      // Skip calculation if hull is in initial unconfigured state (cost is 0)
      // This prevents calculating costs for the default hull configuration
      // Exception: Allow calculation if bridge is selected (auto-selected bridge should be included in costs)
      if (hull && hull.cost === 0 && !state.bridge) {
        console.log("hullAndArmorMiddleware: Skipping calculation - hull not yet configured by user and no bridge selected");
        return result;
      }

      const calculationInput = {
        shipSize,
        hull,
        armor: hull?.armor ?? null,
        hullConfiguration: hull?.configuration ?? null,
        hullOptions: hull?.options || [],
        specializedHull: hull?.specializedType ?? null,
        additionalHull: hull?.additionalType ?? null,
        spunHullPercentage: hull?.additionalType?.percent,
        stealthTier: hull?.options?.find((o) => o.type === "stealth")?.tier,
        techLevel,
      };

      const statsResult = calculateHullAndArmorStats(calculationInput);

      if (statsResult.success && statsResult.data) {
        store.dispatch(setHullAndArmorStats(statsResult.data));
      }
    }

    return result;
  };

export default hullAndArmorMiddleware;
